import { mergeDeepRight } from "@smile2impress/attraction-utils";

export const mergeContent = <T extends object>(
    content: T,
    props: DeepPartial<T>
) => {
    return mergeDeepRight(content, props) as T;
};
